import { AuthenticationService } from '@alfresco/adf-core';
import { Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfigurarPastaServiceService } from 'app/configurar-pasta-service.service';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { DadosAutoriaService } from './dados-autoria.service';
import { DadosAutoriaModel } from './dados-autoria.model';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfirmComponent } from 'app/components/dialog/dialog-confirm/dialog-confirm.component';
import { PermissoesService } from 'app/service/usuario/permissoes.service';

@Component({
  selector: 'app-dados-autoria',
  templateUrl: './dados-autoria.component.html',
  styleUrls: ['./dados-autoria.component.scss']
})
export class DadosAutoriaComponent implements OnInit {

  private arrayString: string;
  public autoriaEditor = false;
  public superUser = false;
  public acervo = false;
  public adm = true;
  public solicitacao = false;
  public loading = false;
  public clienteId: number;
  public dadosAutoriaForm: FormGroup;
  public dadoAutoriaFromArray: FormArray;
  public nodes: any = [];
  public dadosAutoria: any = [];
  public propriedades: any = [];
  public submit = false;
  public manual = false;
  public automatico = false;
  public automatico2 = false;
  public inputDate = false;
  public regras: any = [];
  public isDate = false;
  public dadosAutoriaProp: any = [];
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  public panelOpenState = false;
  public dadosCadastrados;
  public message;
  selectedTab = new FormControl(0);
  public dadoEdit = {} as DadosAutoriaModel;
  public checkedManual = false;
  public checkedAutomatico = false;
  @ViewChild('goToForm') goToForm: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private permissoesService: PermissoesService,
    private dialog: MatDialog,
    private clienteService: ClienteService,
    private fb: FormBuilder,
    private dadosAutoriaService: DadosAutoriaService,
    private _snackBar: MatSnackBar,
    private configPastaService: ConfigurarPastaServiceService,
    private authService: AuthenticationService) {
      this.route.params.subscribe(params => this.clienteId = params['id']);

      this.getPermissionCliente(this.clienteId);
     }

  ngOnInit() {
    console.log(this.dadoEdit);
    this.getDadosDeAutoria();
    this.buscarRegras();
    // Formulário para criar os dados de autoria
    this.dadosAutoriaForm = this.fb.group({
      id: [],
      tipo: [null, Validators.required],
      automatico: [false],
      propriedadeAlfresco: [null, Validators.required],
      regra: [null],
      conteudo: [null],
      cliente: [null]
    });
    this.getCliente(this.clienteId);
    this.getPropriedadesCadastradas();
  }

  getPermissionCliente(idCliente: number) {
    this.loading = true;
    this.permissoesService.getPermissionEmpresa(idCliente).subscribe(data => {
      const arrayAuthorityCliente: any[] = [];
      data.forEach(el => {
        arrayAuthorityCliente.push(el.authority);
      });
      this.permissoesService.setItemAuthority('authority-Empresa', arrayAuthorityCliente);
      this.getAuthority();
      this.loading = false;
    }, err => {
      this.loading = false;
      console.error(err);
      this.openSnackBarError('Ocorreu um erro, tente novamente mais tarde');
    });
  }

  getAuthority() {
    this.arrayString = this.permissoesService.getItemAuthority('authority-Empresa');
    if (this.arrayString.includes('EDIT_DADOS_AUTORIA')) {
      this.autoriaEditor = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  tabClick(e) {
    if (e.index === 1) {
      this.getPropriedadesCadastradas();
      this.checkedAutomatico = false;
      this.checkedManual = false;
    }
    if (e.index === 0) {
      this.getCliente(this.clienteId);
    }
  }

  deleteAspecto(aspectoId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {name: 'Deseja apagar este aspecto ?', from: 'dados-autoria.component.ts'}
    });
    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.apagarAspecto(aspectoId);
      }
    });
  }

  apagarAspecto(aspectoId) {
    this.loading = true;
    this.dadosAutoriaService.apagarDadosAutoriaPorCliente(aspectoId).subscribe(() => {
      this.loading = false;
      this.openSnackBarSuccess('Aspecto de autoria excluído com sucesso !');
      this.getPropriedadesCadastradas();
    }, err => {
      console.error(err);
      this.loading = false;
      this.openSnackBarError('Não foi possível excluir o aspecto ! Tente novamente em instantes.');
    });
  }

  compararTipo(obj1, obj2) {
    return obj1 && obj2
      ? obj1.tipo === obj2.tipo && obj1.id === obj2.id
      : obj1 === obj2;
  }

  compararAspectEdit(obj1, obj2) {
    return obj1 && obj2
      ? obj1.name === obj2.name && obj1.id === obj2.id
      : obj1 === obj2;
  }

  compararRegraEdit(obj1, obj2) {
    return obj1 && obj2
      ? obj1.descricao === obj2.descricao && obj1.id === obj2.id
      : obj1 === obj2;
  }

  editar(dado) {
    console.log(dado);
    this.goToForm.nativeElement.scrollIntoView();
    this.dadosAutoriaForm.get('propriedadeAlfresco').disable();
    this.automatico = true;
    this.manual = true;
    this.selectedTab.setValue(0);
    this.dadoEdit = dado;
    if (this.dadoEdit.automatico === true) {
      this.inputDate = false;
      this.manual = false;
      this.automatico2 = false;
      this.checkedManual = false;
      this.checkedAutomatico = true;
      this.dadosAutoriaForm.get('automatico').setValue(true);
    } else {
      if (this.dadoEdit.propriedadeAlfresco.type === 'd:date') {
        this.manual = false;
        this.automatico2 = true;
        this.automatico = false;
        this.inputDate = true;
        this.checkedAutomatico = false;
        this.checkedManual = true;
        this.dadosAutoriaForm.get('automatico').setValue(false);
      } else {
        this.manual = true;
        this.automatico2 = true;
        this.automatico = false;
        this.inputDate = false;
        this.checkedAutomatico = false;
        this.checkedManual = true;
        this.dadosAutoriaForm.get('automatico').setValue(false);
      }
      this.dadosAutoriaForm.get('automatico').setValue(false);
    }
  }

  editarMetodo() {
    this.dadosAutoriaForm.get('id').setValue(this.dadoEdit.id);
    this.dadosAutoriaForm.get('cliente').setValue(this.dadoEdit.cliente);
    console.log(this.dadoEdit.propriedadeAlfresco);
    this.dadosAutoriaForm.enable();
    this.dadosAutoriaForm.get('propriedadeAlfresco').setValue(this.dadoEdit.propriedadeAlfresco);
    console.log(this.dadosAutoriaForm.value);
    this.dadosAutoriaService.editarDadosAutoriaPorCliente(this.dadosAutoriaForm.value).subscribe(data => {
      console.log(data);
      this.openSnackBarSuccess(`Aspecto editado com sucesso !`);
      this.submit = false;
      this.getPropriedadesCadastradas();
      this.getCliente(this.clienteId);
      this.selectedTab.setValue(1);
      this.dadoEdit.id = null;
    }, err => {
      console.error(err);
      this.openSnackBarError('Erro ao tentar editar o aspecto.');
    });
  }

  selectProp(e) {
    if (e === '3: Object') {
      this.isDate = true;
    } else {
      this.isDate = false;
    }
    this.dadosAutoriaForm.get('automatico').setValue(null);
    this.dadosAutoriaForm.get('regra').setValue(null);
    this.dadosAutoriaForm.get('conteudo').setValue(null);
    this.manual = false;
    this.automatico = false;
    this.inputDate = false;
  }

  buscarRegras() {
    this.dadosAutoriaService.buscarRegras().subscribe(data => {
      this.regras = data;
      console.log(this.regras);
    }, err => {
      console.error(err);
    });
  }

  onSubmit() {
    this.submit = true;
  }

  getSisAutoria() {
    this.nodes.map(el => {
      if (el.name === 'sis:autoria') {
        this.dadosAutoria = el;
      }
    });
    this.propriedades = this.dadosAutoria.propriedades;
  }

  getDadosDeAutoria() {
    this.configPastaService.getDicionarioAutoria().subscribe(data => {
      console.log(data);
      const dadosSistema = data;
      this.nodes = dadosSistema[0].nodes;
      this.getSisAutoria();
    }, err => {
      console.error(err);
    });
  }

  getCliente(id) {
    this.clienteService.getClienteUnico(id).subscribe(data => {
      this.dadosAutoriaForm.get('cliente').setValue(data);
    }, err => {
      console.error(err);
    });
  }

  selected(e) {
    if (e === 'manual' && this.isDate === false) {
      this.automatico = false;
      this.inputDate = false;
      this.manual = true;
      this.checkedAutomatico = false;
      this.checkedManual = true;
      this.dadosAutoriaForm.get('regra').setValue(null);
      this.dadosAutoriaForm.get('automatico').setValue(false);
      this.automatico2 = true;
    } else if (e === 'manual' && this.isDate === true) {
      this.automatico = false;
      this.manual = false;
      this.inputDate = true;
      this.checkedAutomatico = false;
      this.checkedManual = true;
      this.dadosAutoriaForm.get('regra').setValue(null);
      this.dadosAutoriaForm.get('automatico').setValue(false);
      this.automatico2 = true;
    } else {
      this.automatico2 = false;
      this.manual = false;
      this.inputDate = false;
      this.automatico = true;
      this.checkedManual = false;
      this.checkedAutomatico = true;
      this.dadosAutoriaForm.get('conteudo').setValue(null);
      this.dadosAutoriaForm.get('automatico').setValue(true);
    }
  }

  getPropriedadesCadastradas() {
    this.dadosAutoriaService.buscarDadosAutoriaPorCliente(this.clienteId).subscribe(data => {
      this.dadosCadastrados = data;
      if (this.dadosCadastrados.length === 0) {
        this.message = 'Nenhum aspecto foi criado para este cliente !';
      } else {
        this.message = '';
      }
    }, err => {
      console.error(err);
    });
  }

  getDadosAutoriaById(propId, clienteId) {
    this.dadosAutoriaService.buscarPropriedadeByPropAndCliente(propId, clienteId).subscribe(data => {
      this.dadosAutoriaProp = data;
      if (this.dadosAutoriaForm.valid) {
          if (this.dadosAutoriaProp.length < 1) {
            this.salvarBanco();
          } else {
            this.openSnackBarError(`A propriedade já foi criada !`);
            this.submit = false;
          }
      } else {
        this.openSnackBarError('Formulário com erros !');
      }
    }, err => {
      console.error(err);
    });
  }

  saveOrEdit() {
    console.log(this.dadoEdit.id);
    if (this.dadoEdit.id !== undefined && this.dadoEdit.id !== null) {
      console.log('edit');
        this.editarMetodo();
    } else {
      console.log('salvar');
      this.salvar();
    }
  }

  postSubmit() {
    this.submit = false;
    this.dadoEdit.id = null;
    this.manual = false;
    this.automatico = false;
    this.automatico2 = false;
    this.inputDate = false;
    this.getSisAutoria();
    this.getCliente(this.clienteId);
    this.dadosAutoriaForm.get('conteudo').setValue(null);
    this.dadosAutoriaForm.get('propriedadeAlfresco').enable();
  }

  salvar() {
    /*if (this.dadosAutoriaForm.get('automatico').value === 'manual') {
      this.dadosAutoriaForm.get('automatico').setValue(false);
    } else {
      this.dadosAutoriaForm.get('automatico').setValue(true);
    }*/
    const prop = this.dadosAutoriaForm.get('propriedadeAlfresco').value;
    const regra = this.dadosAutoriaForm.get('regra').value;
    if (regra !== null && regra !== undefined) {
      this.dadosAutoriaForm.get('tipo').setValue(regra.tipo);
    }
    console.log('passou aqui');
    this.getDadosAutoriaById(prop.id, this.clienteId);
  }

  salvarBanco() {
    this.dadosAutoriaService.adicionarDadosAutoria(this.dadosAutoriaForm.value).subscribe(data => {
      this.openSnackBarSuccess(`Dado de autoria: '${data.propriedadeAlfresco.title}' adicionado com sucesso !`);
      this.dadosAutoriaForm.reset();
      this.submit = false;
      this.getPropriedadesCadastradas();
      this.getCliente(this.clienteId);
    }, err => {
      console.error(err);
    });
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/dados-autoria/dados-autoria.component.ts